// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"60868":"auth-suite-sdk","79383":"api-service"}[chunkId] || chunkId) + "-" + {"1504":"bdf42f073a926ac9e666","55977":"7b6166af05b24f64c0d5","60868":"1ef7d2756cd12e4dda0b","79383":"8efa0246f335a4f2348d","90768":"1c812180e3967968f973","97049":"c58b9daa55c2bca380ef","97878":"d055ba826f37c695d64a"}[chunkId] + ".min.js";
};